import { mapGetters } from 'vuex';
import { ToastProgrammatic as Toast } from 'buefy';
import dayjs from 'dayjs';

import { FRONT_STAGE_URL } from '@/utils/constants';

export default {
  name: 'CopyLinkModal',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    order: {
      type: Object,
      required: true,
    },
    mode: {
      type: String,
      default: 'published',
    },
  },
  computed: {
    title() {
      return this.mode === 'published' ? '已發佈訂購' : '分享訂購資訊';
    },
    orderLink() {
      if (this.isProduction) {
        return `${FRONT_STAGE_URL.PRODUCTION}/menu/${this.order.id}`;
      }
      /* Local and staging server */
      return `${FRONT_STAGE_URL.STAGING}/menu/${this.order.id}`;
    },
    orderEndTime() {
      return dayjs(this.order.end_time).format('MM/DD HH:mm');
    },
    contentToCopy() {
      /* To open external browser when user share link via LINE */
      const linkToCopy = `${this.orderLink}?openExternalBrowser=1`;
      return `「${this.order.name}」已開放訂購，請於${this.orderEndTime}前下單唷。${linkToCopy}`;
    },
    ...mapGetters(['isProduction']),
  },
  methods: {
    onClose() {
      this.$emit('close');
      this.$emit('input', false);
    },
    onCopySuccess({ contentType = '訂購連結' }) {
      Toast.open({
        message: `${contentType}已複製到剪貼簿`,
        type: 'is-success',
      });
    },
    onCopyError() {
      Toast.open({
        message: '複製訂購連結失敗，請手動複製連結',
        type: 'is-warning',
      });
    },
  },
};
